module.exports = __webpack_public_path__ + "static/11-c63605d4d03d8bdcaaa84e5d7b60c83a.jpg";